module.exports = __webpack_public_path__ + "img/OpenWhite.60487ab6.svg";